import { gql } from '@apollo/client';

export const GET_TOP_VEHICLE_TYPES = gql`
  query GetTopVehicleTypes($filters: DistributionGraphsInput) {
    getTopVehicleTypes(input: $filters) {
      amountOfListings
      label
    }
  }
`;
